<script>
import { mapGetters, mapActions } from 'vuex'
import UserAvatar from '@/components/user/user-avatar.vue'

export default {
  name: 'CandidateImage',
  components: { UserAvatar },
  props: {
    size: {
      type: String,
      default: 'xxl',
    },
    fontSize: {
      type: Number,
      default: null,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    showPreferredIcon: {
      type: Boolean,
      required: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    firstName: {
      type: String,
      default: null,
    },
    lastName: {
      type: String,
      default: null,
    },
    fullName: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      profileImgSrc: null,
    }
  },
  computed: {
    ...mapGetters({
      candidateDisplayPicture: 'candidate/candidateDisplayPicture',
    }),
    compFullName() {
      return (
        this.fullName ??
        (this.id > 0 ? `${this.firstName} ${this.lastName}` : `- -`)
      )
    },
    profilePicture() {
      const picture = this.candidateDisplayPicture(this.id)
      return `data:image/jpeg;base64,${picture}` || null
    },
  },
  async created() {
    await this.getDisplayPic(this.id)
  },
  methods: {
    ...mapActions({
      getDisplayPic: 'candidate/getDisplayPic',
    }),
  },
}
</script>

<template>
  <div class="candidateImage mr-5">
    <UserAvatar
      :name="compFullName"
      :size="size"
      :font-size="fontSize"
      :clickable="id > 0 && clickable"
      :rounded="rounded"
      :badge="showPreferredIcon"
      badge-icon="mdi-star"
      badge-color="orange accent-2"
      :image-url="profilePicture"
      @click="$emit('click')"
    />
  </div>
</template>
